import React from 'react';

function InputLabel({ children, className = '', ...rest }) {
  return (
    <span
      className={`text-coarse-wool font-encode-sans ${className}`}
      {...rest}
    >
      {children}
    </span>
  );
}

export default InputLabel;
